function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.413 9.24271L15 0L10.5869 9.24271L0.5 10.6926L7.70496 17.8511L5.99378 28L15 23.1974L24.0062 28L22.295 17.8511L29.5 10.6926L19.413 9.24271Z",
    fill: "#454545",
    style: {
      fill: "#454545",
      fill: "color(display-p3 0.2692 0.2692 0.2692)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5869 9.24271L15 0V5.39158L12.2863 11.0748L10.5869 9.24271Z",
    fill: "#F9AB30",
    style: {
      fill: "#F9AB30",
      fill: "color(display-p3 0.9765 0.6706 0.1882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0L19.413 9.24271L17.7136 11.0748L15 5.39158V0Z",
    fill: "#FBDE83",
    style: {
      fill: "#FBDE83",
      fill: "color(display-p3 0.9843 0.8706 0.5137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4133 9.24316L29.5002 10.693L23.9164 11.9667L17.7139 11.0753L19.4133 9.24316Z",
    fill: "#FBDE83",
    style: {
      fill: "#FBDE83",
      fill: "color(display-p3 0.9843 0.8706 0.5137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4996 10.6924L22.2946 17.851L19.4854 16.3678L23.9157 11.9661L29.4996 10.6924Z",
    fill: "#F9AB30",
    style: {
      fill: "#F9AB30",
      fill: "color(display-p3 0.9765 0.6706 0.1882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2946 17.8513L24.0058 28.0001L20.5376 22.6086L19.4854 16.3682L22.2946 17.8513Z",
    fill: "#FBDE83",
    style: {
      fill: "#FBDE83",
      fill: "color(display-p3 0.9843 0.8706 0.5137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0062 27.9999L15 23.1973V19.6553L20.538 22.6083L24.0062 27.9999Z",
    fill: "#F9AB30",
    style: {
      fill: "#F9AB30",
      fill: "color(display-p3 0.9765 0.6706 0.1882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 23.1973L5.99414 27.9999L9.46237 22.6083L15.0003 19.6553V23.1973Z",
    fill: "#F9AB30",
    style: {
      fill: "#F9AB30",
      fill: "color(display-p3 0.9765 0.6706 0.1882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99414 28.0001L7.70532 17.8513L10.5146 16.3682L9.46237 22.6086L5.99414 28.0001Z",
    fill: "#FBDE83",
    style: {
      fill: "#FBDE83",
      fill: "color(display-p3 0.9843 0.8706 0.5137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70496 17.851L0.5 10.6924L6.08384 11.9661L10.5142 16.3678L7.70496 17.851Z",
    fill: "#F9AB30",
    style: {
      fill: "#F9AB30",
      fill: "color(display-p3 0.9765 0.6706 0.1882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.693L10.5869 9.24316L12.2864 11.0753L6.08384 11.9667L0.5 10.693Z",
    fill: "#FBDE83",
    style: {
      fill: "#FBDE83",
      fill: "color(display-p3 0.9843 0.8706 0.5137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7137 11.0748L15.0001 5.3916L12.2865 11.0748L6.08398 11.9663L10.5144 16.368L9.46215 22.6084L15.0001 19.6554L20.5381 22.6084L19.4859 16.368L23.9163 11.9663L17.7137 11.0748Z",
    fill: "#FCC853",
    style: {
      fill: "#FCC853",
      fill: "color(display-p3 0.9882 0.7843 0.3255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7137 11.0748L15.0001 5.3916L12.2865 11.0748L6.08398 11.9663L10.5144 16.368L9.46215 22.6084L15.0001 19.6554L20.5381 22.6084L19.4859 16.368L23.9163 11.9663L17.7137 11.0748ZM22.7615 12.3495L17.3516 11.572L15.0001 6.64715L12.6486 11.572L7.23878 12.3495L11.0942 16.18L10.1784 21.6112L15.0001 19.04L19.8219 21.6112L18.9061 16.18L22.7615 12.3495Z",
    fill: "#FFEF9D",
    style: {
      fill: "#FFEF9D",
      fill: "color(display-p3 1.0000 0.9373 0.6157)",
      fillOpacity: 1
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.05d611c3d3dd529075ca7af910edeee1.svg";
export { ForwardRef as ReactComponent };